import { FC, memo } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Typography } from '@mui/material';

const NoTransactionsMessage: FC = () => {
  const { t } = useTranslation();
  return (
    <Box display="flex" justifyContent="center" alignItems="center" height="100%" flexDirection="column" gap={2}>
      <Typography variant="h6">{t('dashboard.transactionsMessage')}</Typography>
    </Box>
  );
};

export default memo(NoTransactionsMessage);
